module.exports = __webpack_public_path__ + "static/media/Huf.a562810d.jpg";